export default __webpack_public_path__ + "static/media/exteriorFinalizat2_2019.253e40b4.jpeg";